import { useMutation } from "@tanstack/react-query";
import { useSnackbar } from "notistack";
import type { OrderEmailType } from "../ordersApi";
import { sendOrderEmail } from "../ordersApi";

export const useCustomerEmails = (orderId: string) => {
  const { enqueueSnackbar } = useSnackbar();

  const sendEmailMutation = useMutation<Record<string, never>, unknown, OrderEmailType>({
    mutationFn: (type) => sendOrderEmail(orderId, type),
    onSuccess: async () => {
      enqueueSnackbar("Wiadomość email została wysłana", { variant: "success" });
    },
    onError: (error) => {
      enqueueSnackbar(`Nie udało się wysłać wiadomości email. Powód: ${(error as Error).message}`, {
        variant: "error",
      });
    },
  });
  return {
    sendEmail: (type: OrderEmailType) => sendEmailMutation.mutateAsync(type),
  };
};
